import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { ReactQRCode } from "@lglab/react-qr-code";


export default function RegisterQRCode({ totemId }) {
  const id = totemId ?? 0;
  const registrationUrl = `https://psicopatici.com/register/${id}`;

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: "20px",
      paddingBottom: "100px",
      backgroundColor: "transparent",
    }}>
      <h1 style={{
        fontSize: "56px",
        fontWeight: "bold",
        marginBottom: "10px",
        color: "#000"
      }}>
        Registrati
      </h1>


      <ReactQRCode
        value={registrationUrl}
        size={280}
        bgColor="transparent"
        fgColor="#000000"
        level="H"
        includeMargin={true}
        style={{ borderRadius: "12px" }}
        dataModulesSettings={{ color: "#000000", style: "rounded", randomSize: false }}
        finderPatternOuterSettings={{ style: "rounded" }}
        finderPatternInnerSettings={{ style: "rounded-sm" }}
        imageSettings={{
            src: "../../../assets/img/qr-code-logo2.png",
            width: 50, height: 50, excavate: true
                                    }}
      />

      <p style={{ marginTop: "0px", fontSize: "16px", color: "#444" }}>
        Scansiona il QR Code per completare la registrazione
      </p>
    </div>
  );
}
